import type { ProcessTemplateResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
export type ProducerProcessTemplateContextProps = {
    localNames: string[];
    processTemplate: ProcessTemplateResource;
};
export interface WithProducerProcessTemplateContextInjectedProps {
    producerProcessTemplateContext?: ProducerProcessTemplateContextProps;
}
export const ProducerProcessTemplateContext = React.createContext<ProducerProcessTemplateContextProps | undefined>(undefined);
export const useOptionalProducerProcessTemplateContext = () => {
    return React.useContext(ProducerProcessTemplateContext);
};
export function buildProducerProcessTemplateContextProps(resource: ProcessTemplateResource): ProducerProcessTemplateContextProps {
    return {
        processTemplate: resource,
        localNames: [...resource.Parameters].sort((a, b) => a.Name.localeCompare(b.Name)).map((p) => p.Name),
    };
}
